module.exports = __webpack_public_path__ + "media/phonering.47e0d160.mp3";